import { Container, Grid, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { LinkButton } from 'components/atoms';
import { ContentDescription } from 'components/structures/general';
import { VideoPopup } from 'components/structures/main/Video';
import { useMediaUp } from 'hooks';
import { bgVideoBlock } from 'images/main';
import { FC } from 'react';

interface VideoBlockProps {
  title: string;
  text?: string;
  button: string;
  link: string;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    resetStyle: {
      [theme.breakpoints.down('sm')]: {
        all: 'unset',
      },
    },
    textBlock: {
      padding: '10px !important',
      [theme.breakpoints.up('sm')]: {
        padding: '0 99px !important',
      },
      [theme.breakpoints.up('md')]: {
        padding: '10px !important',
      },
    },
    videoContent: {
      padding: theme.spacing(5, 0, 6),
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(17, 2, 0, 0),
        height: '100vh',
        maxHeight: 764,
      },
    },
    title: {
      marginBottom: theme.spacing(8),
      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(10),
      },
    },
    button: {
      padding: theme.spacing(3, 8),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(3, 11),
      },
    },
    videoButton: {
      justifyContent: 'center',
      display: 'flex',
    },
    textButton: {
      alignSelf: 'center',
      paddingRight: 0,
      [theme.breakpoints.up('sm')]: {
        paddingRight: 10,
      },
    },
    videoBlock: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("${bgVideoBlock}")`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      minHeight: 406,
      marginBottom: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        minHeight: 460,
        marginRight: 0,
      },
      [theme.breakpoints.up('md')]: {
        marginRight: -37,
      },
    },
  });
});

const VideoBlock: FC<VideoBlockProps> = ({ title, text, button, link }) => {
  const classes = useStyles();
  const isSmallUp = useMediaUp('sm');

  return (
    <Container maxWidth={false} fixed className={classes.resetStyle}>
      <Grid container justifyContent="space-between" spacing={isSmallUp ? 4 : 0}>
        <Grid item xs={12} md={6} className={classes.textBlock}>
          <Grid container justifyContent="space-between" direction="column" className={classes.videoContent}>
            <Grid item>
              <ContentDescription
                upperTitle={{ text: 'What we do' }}
                title={{ text: title, variant: 'h1', className: classes.title }}
              />
              <Grid container spacing={isSmallUp ? 10 : 4}>
                <Grid item>
                  <LinkButton href={link} color="primary" variant="contained" className={classes.button}>
                    {button}
                  </LinkButton>
                </Grid>
                <Grid item className={classes.videoButton}>
                  {!!text && (
                    <Typography variant="body2" component="h5" className={classes.textButton}>
                      {text}
                    </Typography>
                  )}
                  <VideoPopup reverse />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6} className={classes.videoBlock}>
          <VideoPopup />
        </Grid>
      </Grid>
    </Container>
  );
};

export default VideoBlock;
